/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Col_ImportInputs */

const en_hub_col_import = /** @type {(inputs: Hub_Col_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import`)
};

const id_hub_col_import = /** @type {(inputs: Hub_Col_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impor`)
};

/**
* | output |
* | --- |
* | "Import" |
*
* @param {Hub_Col_ImportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_col_import = /** @type {((inputs?: Hub_Col_ImportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Col_ImportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_col_import(inputs)
	return en_hub_col_import(inputs)
});